import React from 'react';
import PropTypes from 'prop-types';
import { useDataContext } from 'common/lib/helpers/DataContext';
import * as _ from 'lodash';
import { NO_IMAGE_SRC } from 'common/lib/helpers/constants';
import { trackEventViewCustomerContent } from 'common/lib/helpers/trackingService';
import { Card } from '@fabric-ds/react';

const ModuleCard = ({ moduleData, index }) => {
    const { imageHost } = useDataContext();
    const { description, heading, url, urlText, image } = moduleData;

    const imagePath = !_.isEmpty(image) ? `${imageHost}/dynamic/480x480c/${image.path}` : NO_IMAGE_SRC;

    return (
        <Card flat style={{ cursor: 'default' }}>
            <img className="h-fit w-full object-cover" src={imagePath} alt={`Bilde ${index + 1}`} />
            <div className="p-16">
                <h4>{heading}</h4>
                <p>{description}</p>
                {!_.isEmpty(url) && (
                    <a
                        id="module-link"
                        href={url}
                        rel="noopener nofollow noreferrer external"
                        target="_blank"
                        onClick={() => trackEventViewCustomerContent()}
                    >
                        {urlText || url}
                    </a>
                )}
            </div>
        </Card>
    );
};

ModuleCard.propTypes = {
    moduleData: PropTypes.shape({
        description: PropTypes.string,
        heading: PropTypes.string,
        urlText: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.shape({
            path: PropTypes.string,
            caption: PropTypes.string,
        }),
    }),
    index: PropTypes.number,
};

const ContentModule = ({ contentModule }) => {
    if (contentModule) {
        const { mainHeading, modules, showContentModule } = contentModule;

        if (!showContentModule) {
            return null;
        }
        return (
            <div className="pt-64 pb-32">
                {mainHeading && <h3 className="mb-32">{mainHeading}</h3>}
                <div className="grid grid-cols-1 gap-32 sm:grid-cols-3">
                    {modules.map((module, index) => {
                        return <ModuleCard moduleData={module} key={index} index={index} />;
                    })}
                </div>
            </div>
        );
    }
    return null;
};

ContentModule.propTypes = {
    contentModule: PropTypes.object,
};

export default ContentModule;
